import React from "react";
import { withRouter, Link } from "react-router-dom";
import * as Scroll from "react-scroll";
// import axios from "axios";
// import { toast } from "react-toastify";
import logo from "../images/logo.svg";
import mashroom from "../images/mashroom.svg";
import twitter from "../images/twitter.svg";
import telegram from "../images/telegram.svg";
import msg from "../images/msg.svg";
import yt from "../images/yt.svg";
import linkedin from "../images/in.svg";
import mail from "../images/mail.svg";
import band from "../images/band.png";

let Links = Scroll.Link;

const Footer = ({ history }) => {
  // const [disable, setDisable] = useState(false);
  // const emailRef = useRef();

  // const subscripeEmail = async () => {
  //   setDisable(true);
  //   const email = emailRef.current.value;
  //   try {
  //     const response = await axios.post(
  //       `/api/app/notification/subscribe/email?email=${email}`
  //     );
  //     toast.success("Email Subscribed!");
  //     emailRef.current.value = "";
  //     setDisable(false);
  //     console.log(response);
  //   } catch (e) {
  //     setDisable(false);
  //     toast.error(e.response?.data?.message);
  //     console.log(e);
  //   }
  // };

  // const keyHandler = (e) => {
  //   if (e.key === "Enter") {
  //     subscripeEmail();
  //   }
  // };
  return (
    <section className="footer">
      <footer>
        <div className="container-fluid p-4">
          <div className="row mt-5">
            <div className="col-md-1  mb-4 mb-md-0"></div>
            <div className="col-md-3 mb-4 mb-md-0">
              <img src={logo} alt="" className="mb-4" width="150" />
              <p>
                Monsters Clan is a first ever NFT game based on a lifestyle of
                Monsters allowing players to control their monsters and fight
                their battles.
              </p>
              <p>
                <img src={mail} alt="" /> hi@monstersclan.com
              </p>
              <p>Monsters Labs OÜ (registry code 16292068)</p>
              <p>
                Pärnu maakond, Pärnu linn, Pärnu linn, Papiniidu tn 5, 80042
              </p>
            </div>
            <div className="col-md-2 mb-4 mb-md-0">
              <h5 className="text-uppercase heading mb-3">MonstersClan</h5>

              <ul className="list-unstyled mb-0">
                <li>
                  <Links
                    onClick={() => {
                      history.push("/");
                    }}
                    className="scroller"
                    to="game"
                    spy={false}
                    smooth={true}
                    offset={-100}
                    duration={800}
                  >
                    {" "}
                    Game Mechanics
                  </Links>
                </li>
                <li>
                  <Links
                    onClick={() => {
                      history.push("/");
                    }}
                    className="scroller"
                    to="monster"
                    spy={false}
                    smooth={true}
                    offset={-100}
                    duration={800}
                  >
                    Monsters
                  </Links>
                </li>
                <li>
                  <Links
                    onClick={() => {
                      history.push("/");
                    }}
                    className="scroller"
                    to="team"
                    spy={false}
                    smooth={true}
                    offset={-100}
                    duration={1000}
                  >
                    Team
                  </Links>
                </li>
                <li>
                  <Link to="/">Marketplace</Link>
                </li>
                {/* <li>
                  <Link to="/toknomics">Tokenomics</Link>
                </li> */}
                <li>
                  <Links
                    onClick={() => {
                      history.push("/");
                    }}
                    className="scroller"
                    to="secure"
                    spy={false}
                    smooth={true}
                    offset={-100}
                    duration={800}
                  >
                    Audit
                  </Links>
                </li>
              </ul>
            </div>
            <div className="col-md-2 mb-4 mb-md-0">
              <h5 className="text-uppercase heading mb-3">Resources</h5>

              <ul className="list-unstyled">
                {/* <li>
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href="https://drive.google.com/file/d/1LNEh0_sJkuyKeYXdh6mTNHfAhWbnpiK2/view"
                  >
                    Grumpy Paper
                  </a>
                </li>
                <li>
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href="https://drive.google.com/file/d/1ZTxNkeZTHJWKSt860vBpEoZtIhvb4CJF/view"
                  >
                    Investment Deck
                  </a>
                </li> */}
                <li>
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href="https://drive.google.com/drive/folders/1vwjSOYu1uyV0ECezf9d4GzNltBYqx5i2?usp=sharing"
                  >
                    Media Kit
                  </a>
                </li>
              </ul>
            </div>
            <div className="col-md-3 mb-4 mb-md-0">
              {/* <h5 className="text-uppercase heading mb-3">
                Sign Up for Newsletter
              </h5>
              <div className="input-group mb-3">
                <div className="input-div">
                  <input
                    onKeyDown={keyHandler}
                    placeholder="Enter your email"
                    ref={emailRef}
                    type="text"
                    className="form-control"
                  />
                </div>
                <button
                  onClick={subscripeEmail}
                  className="btn buy"
                  disabled={disable}
                  type="button"
                >
                  Sign Up
                </button>
              </div> */}
              <p className="connect">Follow Us</p>

              <div className="social">
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://medium.com/@monstersclan "
                >
                  {" "}
                  <img src={telegram} alt="" />
                </a>
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://twitter.com/_Monstersclan"
                >
                  {" "}
                  <img src={twitter} alt="" />
                </a>
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://t.me/MONSofficial"
                >
                  <img src={msg} alt="" />
                </a>
                <a target="_blank" rel="noreferrer" href="http://t.me/MONS_Ann">
                  <img src={band} alt="" />
                </a>
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://www.youtube.com/@monstersclangame"
                >
                  <img src={yt} alt="" />
                </a>
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://www.linkedin.com/company/monstersclan/"
                >
                  <img src={linkedin} alt="" />
                </a>
              </div>
            </div>
            <div className="col-md-1 mb-4 mb-md-0"></div>
          </div>
        </div>
        <img className="mashroom-img" src={mashroom} alt="" />
        <div className="text-center p-3">
          Copyrights 2024-2025 | MonstersClan.com All rights reserved.
        </div>
      </footer>
    </section>
  );
};

export default withRouter(Footer);
